/**
 * 会議操作タイプ
 */
export var SessionActionTypes;

(function (SessionActionTypes) {
  /**
   * 未定義
   */
  SessionActionTypes[SessionActionTypes["Unknown"] = 0] = "Unknown";
  /**
   * 作成
   */

  SessionActionTypes[SessionActionTypes["Created"] = 1] = "Created";
  /**
   * 追加
   */

  SessionActionTypes[SessionActionTypes["Added"] = 2] = "Added";
  /**
   * 更新
   */

  SessionActionTypes[SessionActionTypes["Updated"] = 3] = "Updated";
  /**
   * 削除
   */

  SessionActionTypes[SessionActionTypes["Deleted"] = 4] = "Deleted";
  /**
   * コピー
   */

  SessionActionTypes[SessionActionTypes["Copied"] = 5] = "Copied";
  /**
   * 保存
   */

  SessionActionTypes[SessionActionTypes["Saved"] = 6] = "Saved";
  /**
   * 参加
   */

  SessionActionTypes[SessionActionTypes["Joined"] = 7] = "Joined";
  /**
   * 退出
   */

  SessionActionTypes[SessionActionTypes["Exited"] = 8] = "Exited";
  /**
   * 開始
   */

  SessionActionTypes[SessionActionTypes["Started"] = 9] = "Started";
  /**
   * 終了
   */

  SessionActionTypes[SessionActionTypes["Ended"] = 10] = "Ended";
  /**
   * 読込
   */

  SessionActionTypes[SessionActionTypes["Loaded"] = 11] = "Loaded";
  /**
   * ダウンロード
   */

  SessionActionTypes[SessionActionTypes["Downloaded"] = 12] = "Downloaded";
  /**
   * 編集
   */

  SessionActionTypes[SessionActionTypes["Edit"] = 100] = "Edit";
  /**
   * 再生
   */

  SessionActionTypes[SessionActionTypes["Play"] = 101] = "Play";
  /**
   * 遷移
   */

  SessionActionTypes[SessionActionTypes["Next"] = 102] = "Next";
  /**
   * 戻る
   */

  SessionActionTypes[SessionActionTypes["Back"] = 103] = "Back";
  /**
   * リセット
   */

  SessionActionTypes[SessionActionTypes["Reset"] = 104] = "Reset";
  /**
   * 選択
   */

  SessionActionTypes[SessionActionTypes["Select"] = 105] = "Select";
  /**
   * 回答
   */

  SessionActionTypes[SessionActionTypes["Answer"] = 106] = "Answer";
  /**
   * 発話
   */

  SessionActionTypes[SessionActionTypes["Spoken"] = 107] = "Spoken";
})(SessionActionTypes || (SessionActionTypes = {}));